import React, { useState, useEffect } from 'react';
import "../../Styles/PacksSelect.css";
import { useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUpLong } from "@fortawesome/free-solid-svg-icons";
import packslist from "../../../JSONS/updatedPacks.json"
import MakeItEasy from "./MakeItEasy"
import LazyLoad from 'react-lazyload';
import CryptoJS from "crypto-js";
import { jwtDecode } from 'jwt-decode';

function PacksSelect() {
  const Navigate = useNavigate();

  const Token = sessionStorage.getItem('token') ? sessionStorage.getItem('token') : null;
  const decodedToken = Token ? jwtDecode(CryptoJS.AES.decrypt(Token, process.env.REACT_APP_TOKEN_ENC,{ mode: CryptoJS.mode.CBC, padding: CryptoJS.pad.Pkcs7 }).toString(CryptoJS.enc.Utf8)) : null;
  const Gender = decodedToken ? parseInt(decodedToken.gender) : null;
  const GenderCat = Gender === 1 ? "M" : "F"

  const [VisualizePack,SetVisualizePack] = useState("")

  const [Category, setCategory] = useState("Preventivo");
  const [ChosenToSee, setChosenToSee] = useState(false);
  const [PacksShown, setPacksShown] = useState(Object.keys(packslist).filter(a => packslist[a].category.includes("Preventivo") && packslist[a].gender === GenderCat))

  useEffect(() => {
    if(ChosenToSee) {
        document.body.scrollTop = 0
        document.documentElement.scrollTop = 0
        Navigate("/packs-de-examenes/detalles-de-pack?pack=".concat(VisualizePack))
    }
  }, [ChosenToSee, VisualizePack, Navigate]);

  window.onscroll = function() {
    if(document.URL.includes("todos-los-packs")) {
      let tmp = document.getElementById("ToTheTop")
      if (document.body.scrollTop > 100 || document.documentElement.scrollTop > 100) {
        tmp.className = tmp.className.replace(" ScrollBackToTopHidden", "");
      } else {
        if(!tmp.className.includes("ScrollBackToTopHidden")) tmp.className += " ScrollBackToTopHidden"
      }
    }
  }

  function toggleCategoryTab(current) {
    if(Category !== current) {
        let tmp = document.getElementsByClassName('PacksSelectCategoryTab')
        for(let i=0;i<tmp.length;i++) {
            if(tmp[i].classList.contains("PacksSelectActiveCategory")) {
                tmp[i].className = tmp[i].className.replace(" PacksSelectActiveCategory", "");
            }
        }
        let tmp2 = document.getElementById(current)
        tmp2.className += " PacksSelectActiveCategory"
        setCategory(current)

        if(current === "AllCats") {
            setPacksShown(Object.keys(packslist).filter(a => packslist[a].gender === GenderCat))
        } else {
            setPacksShown(Object.keys(packslist).filter(a => packslist[a].category.includes(current) && packslist[a].gender === GenderCat))
        }
    }
  }

  function toggleDescription(id,type) {
    let tmp = document.getElementById(id.concat("More"))
    let tmp2 = document.getElementById(id.concat("Less"))
    if(type === "More") {
        tmp.className += " PacksSelectPackBoxWhiteBoxDescriptionHidden"
        tmp2.className = tmp2.className.replace(" PacksSelectPackBoxWhiteBoxDescriptionHidden", "");
    } else {
        tmp.className = tmp.className.replace(" PacksSelectPackBoxWhiteBoxDescriptionHidden", "");
        tmp2.className += " PacksSelectPackBoxWhiteBoxDescriptionHidden"
    }
  }

  return (
    <div className="PacksSelectOuterDiv">
        <div className="UserProfileInnerDiv">
            <div className='UserProfileWhiteBox PacksSelectWhiteBlock' style={{color:"#330066", marginBlockEnd:"20px"}}>
                <h5 className="UserProfilePageUpTitle">Órdenes Médicas</h5>
                <div className='PacksSelectUpperFlex'>
                    <div className='PacksSelectFirstBlock'>
                        <img className='OrderCheckoutEmptyBlockImage' alt="" src="https://static.yomecontrolo.cl/public/B2B/ProfileWelcomeImage8Vect.svg" />
                        <div className='PacksSelectFirstBlockTexts'>
                            <h3 className="PacksSelectFirstBlockTitle">Crea, personaliza, descarga y revisa <span style={{fontStyle: "italic", fontWeight: "800"}}>tus exámenes en un mismo lugar</span></h3>
                            <div className="PacksSelectFirstBlockSubtitle">Órdenes de exámenes, procedimientos y derivaciones.
                                <br/><br/>Con estas órdenes médicas puedes presentarte directamente a cualquier laboratorio del país.</div>
                            <div className='LandingSlider2RightSideButtonFlex' onClick={() => Navigate("/recomendador-de-examenes")}>
                                <div className='LandingSlider2RightSideButtonLeft'>
                                Crear Orden Personalizada
                                </div>
                                <div className="LandingSlider2RightSideButtonRight">
                                    <img alt="" className="LandingSlider2RightSideButtonRightImage" src="https://static.yomecontrolo.cl/public/icons/WhiteExamIcon.png"/>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className='PacksSelectSecondBlock' onClick={() => Navigate("/orden-medica/historial-de-ordenes")}>
                        <h5 className='PacksSelectSecondBlockUpText'>Órdenes pasadas</h5>
                        <h4 className='UserProfileBigButtonBackUpText' style={{zIndex:"3"}}>Historial de Órdenes de Exámenes</h4>
                        <img alt="" className='PacksSelectSecondBlockImage' src="https://static.yomecontrolo.cl/public/B2B/ProfileWelcomeImage3Transparent.png" />
                    </div>
                </div>
                <div className='PacksSelectPackBlockBackground'>
                    <div className='PacksSelectPackBlockUpTitle'>Packs de Exámenes</div>
                    <h2 className='PacksSelectPackBlockTitle'>Packs de Exámenes</h2>
                    <div className='PacksSelectCategoryTabsFlex'>
                        <div className='PacksSelectCategoryTab PacksSelectActiveCategory' id="Preventivo" onClick={() => toggleCategoryTab("Preventivo")}>Preventivos</div>
                        <div className='PacksSelectCategoryTab' id="Control" onClick={() => toggleCategoryTab("Control")}>Control</div>
                        <div className='PacksSelectCategoryTab' id="Detección" onClick={() => toggleCategoryTab("Detección")}>Detección</div>
                        <div className='PacksSelectCategoryTab' id="AllCats" onClick={() => toggleCategoryTab("AllCats")}>Todos</div>
                    </div>
                    <div className="PacksSelectPackBoxesFlex">
                        {PacksShown.map((pack) => (
                        <div className="PacksSelectPackBox" key={pack}>
                            <LazyLoad once >
                            <div className='PacksSelectPackBoxBackImage' style={{backgroundImage:"linear-gradient(0deg, rgba(207,249,255,1) 0%, rgba(255,255,255,0) 50%),url('https://static.yomecontrolo.cl/public/img/packs/"+ pack +".png')",backgroundPosition: 'center',backgroundSize: 'cover',backgroundRepeat: 'no-repeat'}}></div>
                            </LazyLoad>
                            <div className="PacksSelectPackBoxGradient">
                                <div className="PacksSelectPackBoxWhiteBox">
                                    <div className="PacksSelectPackBoxWhiteBoxTitle">{packslist[pack].name}</div>
                                    <div className="PacksSelectPackBoxWhiteBoxDescription" id={pack.concat("More")}>{packslist[pack].description.split(' ').slice(0,12).join(' ')} &nbsp;
                                        <span className='PacksSelectPackBoxWhiteBoxTextOption' onClick={() => toggleDescription(pack,"More")}>Leer más...</span>
                                    </div>
                                    <div className="PacksSelectPackBoxWhiteBoxDescription PacksSelectPackBoxWhiteBoxDescriptionHidden" id={pack.concat("Less")}>{packslist[pack].description} &nbsp;
                                        <span className='PacksSelectPackBoxWhiteBoxTextOption' onClick={() => toggleDescription(pack,"Less")}>Leer menos...</span>
                                    </div>
                                    <div className="PacksSelectPackBoxWhiteBoxFlex">
                                        <div className="PacksSelectPackBoxWhiteBoxPrice">${packslist[pack].price}</div>
                                    </div>
                                    <div className="PacksSelectPackBoxWhiteBoxMoreInfoButton" onClick={() => {SetVisualizePack(pack); setChosenToSee(true);}}>Más Información</div>
                                </div>
                            </div>
                        </div>
                        ))}
                        {Category === "AllCats" ?
                        <>
                        {Object.keys(packslist).filter(a => packslist[a].gender === "Mixed").map((pack) => (
                        <div className="PacksSelectPackBox" key={pack}>
                            <LazyLoad once >
                            <div className='PacksSelectPackBoxBackImage' style={{backgroundImage:"linear-gradient(0deg, rgba(207,249,255,1) 0%, rgba(255,255,255,0) 50%),url('https://static.yomecontrolo.cl/public/img/packs/"+ pack +".png')",backgroundPosition: 'center',backgroundSize: 'cover',backgroundRepeat: 'no-repeat'}}></div>
                            </LazyLoad>
                            <div className="PacksSelectPackBoxGradient">
                                <div className="PacksSelectPackBoxWhiteBox">
                                    <div className="PacksSelectPackBoxWhiteBoxTitle">{packslist[pack].name}</div>
                                    <div className="PacksSelectPackBoxWhiteBoxDescription" id={pack.concat("More")}>{packslist[pack].description.split(' ').slice(0,12).join(' ')} &nbsp;
                                        <span className='PacksSelectPackBoxWhiteBoxTextOption' onClick={() => toggleDescription(pack,"More")}>Leer más...</span>
                                    </div>
                                    <div className="PacksSelectPackBoxWhiteBoxDescription PacksSelectPackBoxWhiteBoxDescriptionHidden" id={pack.concat("Less")}>{packslist[pack].description} &nbsp;
                                        <span className='PacksSelectPackBoxWhiteBoxTextOption' onClick={() => toggleDescription(pack,"Less")}>Leer menos...</span>
                                    </div>
                                    <div className="PacksSelectPackBoxWhiteBoxFlex">
                                        <div className="PacksSelectPackBoxWhiteBoxPrice">${packslist[pack].price}</div>
                                    </div>
                                    <div className="PacksSelectPackBoxWhiteBoxMoreInfoButton" onClick={() => {SetVisualizePack(pack); setChosenToSee(true);}}>Más Información</div>
                                </div>
                            </div>
                        </div>
                        ))}
                        </>
                        : 
                        <>
                        {Object.keys(packslist).filter(a => packslist[a].category.includes(Category) & packslist[a].gender === "Mixed").map((pack) => (
                        <div className="PacksSelectPackBox" key={pack}>
                            <LazyLoad once >
                            <div className='PacksSelectPackBoxBackImage' style={{backgroundImage:"linear-gradient(0deg, rgba(207,249,255,1) 0%, rgba(255,255,255,0) 50%),url('https://static.yomecontrolo.cl/public/img/packs/"+ pack +".png')",backgroundPosition: 'center',backgroundSize: 'cover',backgroundRepeat: 'no-repeat'}}></div>
                            </LazyLoad>
                            <div className="PacksSelectPackBoxGradient">
                                <div className="PacksSelectPackBoxWhiteBox">
                                    <div className="PacksSelectPackBoxWhiteBoxTitle">{packslist[pack].name}</div>
                                    <div className="PacksSelectPackBoxWhiteBoxDescription" id={pack.concat("More")}>{packslist[pack].description.split(' ').slice(0,12).join(' ')} &nbsp;
                                        <span className='PacksSelectPackBoxWhiteBoxTextOption' onClick={() => toggleDescription(pack,"More")}>Leer más...</span>
                                    </div>
                                    <div className="PacksSelectPackBoxWhiteBoxDescription PacksSelectPackBoxWhiteBoxDescriptionHidden" id={pack.concat("Less")}>{packslist[pack].description} &nbsp;
                                        <span className='PacksSelectPackBoxWhiteBoxTextOption' onClick={() => toggleDescription(pack,"Less")}>Leer menos...</span>
                                    </div>
                                    <div className="PacksSelectPackBoxWhiteBoxFlex">
                                        <div className="PacksSelectPackBoxWhiteBoxPrice">${packslist[pack].price}</div>
                                    </div>
                                    <div className="PacksSelectPackBoxWhiteBoxMoreInfoButton" onClick={() => {SetVisualizePack(pack); setChosenToSee(true);}}>Más Información</div>
                                </div>
                            </div>
                        </div>
                        ))}
                        </>
            }
                    </div>
                </div>
            </div>
        </div>
        <MakeItEasy/>
        <div className='ScrollBackToTopOuter ScrollBackToTopHidden' id="ToTheTop">
            <div className='ScrollBackToTop' onClick={() => {document.body.scrollTop = 0; document.documentElement.scrollTop = 0;}}>
            <FontAwesomeIcon 
                icon={faUpLong} 
                className='ScrollBackToTopUpArrow'
            />
            </div>
        </div>
    </div>
    
  );
}

export default PacksSelect;
